import React, { createContext, useContext, useEffect, useState } from "react";
import { createPortal } from "react-dom";
import Select from "react-select";
import { LuChevronDown, LuX } from "react-icons/lu";
import { SCROLL_CLASS } from "./BotCard";

export const CONFIG_CSS = `
.su-cd { position: fixed; top: 0; right: 0; bottom: 0; z-index: 1250; width: 430px; max-width: 100%; display: flex; flex-direction: column; margin: 0; border-left: 1px solid var(--su-line); background: var(--su-surface); box-shadow: -16px 0 40px -16px rgba(0, 0, 0, 0.35); }
.su-cd-h { display: flex; align-items: center; gap: 10px; height: 64px; padding: 0 14px; border-bottom: 1px solid var(--su-line-2); flex-shrink: 0; }
.su-cd-x { width: 38px; height: 38px; flex-shrink: 0; display: grid; place-items: center; border: none; border-radius: 10px; background: none; color: var(--su-ink); cursor: pointer; }
.su-cd-x:hover { background: var(--su-raised); }
.su-cd-t { flex: 1; min-width: 0; }
.su-cd-t b { display: block; font-size: 19px; font-weight: 600; line-height: 1.2; color: var(--su-ink); }
.su-cd-t small { display: block; font-size: 12.5px; color: var(--su-ink-3); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.su-cd-b { flex: 1; min-height: 0; overflow-y: auto; }
.su-cd-f { display: flex; align-items: center; justify-content: flex-end; gap: 8px; padding: 12px 16px; border-top: 1px solid var(--su-line); background: var(--su-surface); flex-shrink: 0; }
.su-cd-f.dirty { background: var(--su-note-bg); border-top-color: var(--su-note-line); }
.su-cd-f span { flex: 1; min-width: 0; font-size: 13px; font-weight: 600; color: var(--su-ink); }
.su-acc { border-bottom: 1px solid var(--su-line-2); }
.su-acc-h { display: flex; align-items: center; gap: 10px; width: 100%; padding: 13px 16px; border: none; background: none; color: var(--su-ink); text-align: left; cursor: pointer; }
.su-acc-h:hover { background: var(--su-hover); }
.su-acc-ic { width: 30px; height: 30px; flex-shrink: 0; display: grid; place-items: center; border-radius: 9px; color: #ffffff; }
.su-acc-t { flex: 1; min-width: 0; display: flex; flex-direction: column; gap: 1px; }
.su-acc-t b { font-size: 17px; font-weight: 600; line-height: 1.25; }
.su-acc-t small { font-size: 12.5px; color: var(--su-ink-3); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.su-acc-c { color: var(--su-ink-3); transition: transform 0.15s; }
.su-acc.open .su-acc-c { transform: rotate(180deg); }
.su-acc-b { display: flex; flex-direction: column; gap: 16px; padding: 4px 16px 18px; }
.su-cf-sub { margin-top: 4px; font-size: 11.5px; font-weight: 600; letter-spacing: 0.05em; text-transform: uppercase; color: var(--su-ink-3); }
.su-cf { display: flex; flex-direction: column; gap: 4px; min-width: 0; }
.su-kit .su-cf label, .su-cf-label { margin: 0; font-size: 12px; font-weight: 600; color: var(--su-ink-3); }
.su-cf-row { display: flex; align-items: center; justify-content: space-between; gap: 12px; font-size: 14.5px; color: var(--su-ink); }
.su-cf-row > div { min-width: 0; }
.su-cf-row small, .su-cf-hint { display: block; margin-top: 1px; font-size: 12px; line-height: 1.4; color: var(--su-ink-3); }
.su-kit .su-cf-box { width: 100%; padding: 9px 11px; border: 1px solid var(--su-line) !important; border-radius: 10px; outline: none; box-shadow: none !important; background: var(--su-surface) !important; color: var(--su-ink) !important; font-family: inherit; font-size: 14px; line-height: 1.45; resize: none; }
.su-kit .su-cf-box:focus { border-color: var(--su-sky) !important; }
.su-kit .su-cf-line { width: 100%; padding: 7px 2px; border: none !important; border-bottom: 1px solid var(--su-line) !important; border-radius: 0; outline: none; box-shadow: none !important; background: transparent !important; color: var(--su-ink) !important; font-family: inherit; font-size: 14.5px; }
.su-kit .su-cf-line:focus { border-bottom-color: var(--su-sky) !important; }
.su-kit .su-cf-box::placeholder, .su-kit .su-cf-line::placeholder { color: var(--su-ink-3); font-style: normal; }
.su-cf-err { font-size: 12px; color: var(--su-red-ink); }
.su-cf-tabs { display: flex; gap: 18px; border-bottom: 1px solid var(--su-line); }
.su-cf-tabs button { display: inline-flex; align-items: center; gap: 6px; margin-bottom: -1px; padding: 9px 0; border: none; border-bottom: 2.5px solid transparent; background: none; color: var(--su-ink-4); font-size: 14px; font-weight: 600; cursor: pointer; }
.su-cf-tabs button.on { color: var(--su-ink); border-bottom-color: var(--su-sky); }
.su-cf-seg { display: grid; grid-template-columns: 1fr 1fr; gap: 6px; margin-top: 2px; }
.su-cf-seg button { padding: 8px; border: 1px solid var(--su-line); border-radius: 9px; background: var(--su-surface); color: var(--su-ink-2); font-size: 13px; font-weight: 600; cursor: pointer; }
.su-cf-seg button.on { border-color: var(--su-accent-ink); background: var(--su-chip-on); color: var(--su-accent-ink); }
.su-cf-two { display: grid; grid-template-columns: 130px minmax(0, 1fr); gap: 12px; }
.su-cd-menus { position: fixed; top: 0; left: 0; z-index: 1260; }
.su-kit { --su-note-bg: #fffbe6; --su-note-line: #f5ecc0; }
#body-dark.dark .su-kit { --su-note-bg: #2b2a1c; --su-note-line: #4a4526; }
`;

const SELECT_STYLES = {
    control: (base, state) => ({
        ...base,
        minHeight: "34px",
        border: "none",
        borderBottom: `1px solid ${state.isFocused ? "var(--su-sky)" : "var(--su-line)"}`,
        borderRadius: 0,
        boxShadow: "none",
        backgroundColor: "transparent",
        cursor: "pointer",
        "&:hover": { borderBottomColor: "var(--su-control)" },
    }),
    valueContainer: (base) => ({ ...base, padding: "2px" }),
    singleValue: (base) => ({ ...base, color: "var(--su-ink)", fontSize: "14.5px" }),
    placeholder: (base) => ({ ...base, color: "var(--su-ink-3)", fontSize: "14.5px" }),
    input: (base) => ({ ...base, color: "var(--su-ink)" }),
    indicatorSeparator: () => ({ display: "none" }),
    dropdownIndicator: (base) => ({ ...base, padding: "4px", color: "var(--su-ink-3)" }),
    menuPortal: (base) => ({ ...base, zIndex: 1261 }),
    menu: (base) => ({ ...base, border: "1px solid var(--su-line)", borderRadius: "12px", backgroundColor: "var(--su-surface)", boxShadow: "var(--su-shadow)", overflow: "hidden" }),
    menuList: (base) => ({ ...base, padding: "6px" }),
    option: (base, state) => ({
        ...base,
        borderRadius: "8px",
        fontSize: "14px",
        cursor: "pointer",
        color: state.isSelected ? "var(--su-accent-ink)" : "var(--su-ink)",
        backgroundColor: state.isSelected ? "var(--su-chip-on)" : state.isFocused ? "var(--su-hover)" : "transparent",
    }),
    noOptionsMessage: (base) => ({ ...base, color: "var(--su-ink-3)", fontSize: "13px" }),
};

const MenuTargetContext = createContext(null);

export const SuSelect = (props) => {
    const menuTarget = useContext(MenuTargetContext);
    return (
        <Select
            styles={SELECT_STYLES}
            placeholder="Seleccionar"
            noOptionsMessage={() => "Sin opciones"}
            menuPortalTarget={menuTarget}
            menuPosition="fixed"
            {...props}
        />
    );
};

export const SuSwitch = ({ checked, onChange, label }) => (
    <button
        type="button"
        role="switch"
        aria-checked={Boolean(checked)}
        aria-label={label}
        className={`su-sw${checked ? " on" : ""}`}
        onClick={() => onChange(!checked)}
    >
        <span />
    </button>
);

export const SwitchRow = ({ label, hint, checked, onChange }) => (
    <div className="su-cf-row">
        <div>
            {label}
            {hint && <small>{hint}</small>}
        </div>
        <SuSwitch checked={checked} onChange={onChange} label={label} />
    </div>
);

export const ConfigSection = ({ id, active, setActive, icon: Icon, color, title, summary, children }) => {
    const open = active === id;
    return (
        <div className={`su-acc${open ? " open" : ""}`} style={{ "--c": color }}>
            <button type="button" className="su-acc-h" aria-expanded={open} onClick={() => setActive(open ? null : id)}>
                <span className="su-acc-ic" style={{ backgroundColor: color }}>
                    <Icon className="su-ic" size={16} />
                </span>
                <span className="su-acc-t">
                    <b>{title}</b>
                    {!open && <small title={summary}>{summary}</small>}
                </span>
                <LuChevronDown className="su-ic su-acc-c" size={16} />
            </button>
            {open && <div className="su-acc-b">{children}</div>}
        </div>
    );
};

export const ConfigDrawer = ({ open, subtitle, dirty, blocked, onClose, onDiscard, onSubmit, children }) => {
    const [menuTarget, setMenuTarget] = useState(null);

    useEffect(() => {
        if (!open) return undefined;
        const onKeyDown = (event) => {
            if (event.key === "Escape" && !blocked) onClose();
        };
        document.addEventListener("keydown", onKeyDown);
        return () => document.removeEventListener("keydown", onKeyDown);
    }, [open, blocked, onClose]);

    if (!open) return null;

    return createPortal(
        <div className="su-kit">
            <style>{CONFIG_CSS}</style>
            <div className="su-cd-menus" ref={setMenuTarget} />
            <form className="su-cd" role="dialog" aria-label="Configuración del bot" onSubmit={onSubmit} noValidate>
                <div className="su-cd-h">
                    <button type="button" className="su-cd-x" aria-label="Cerrar" onClick={onClose}>
                        <LuX className="su-ic" size={18} />
                    </button>
                    <div className="su-cd-t">
                        <b>Configuración</b>
                        <small title={subtitle}>{subtitle}</small>
                    </div>
                </div>
                <div className={`su-cd-b ${SCROLL_CLASS}`}>
                    <MenuTargetContext.Provider value={menuTarget}>{children}</MenuTargetContext.Provider>
                </div>
                <div className={`su-cd-f${dirty ? " dirty" : ""}`}>
                    {dirty && <span>Cambios sin guardar</span>}
                    <button type="button" className="su-btn ghost" onClick={onDiscard}>
                        {dirty ? "Descartar" : "Cerrar"}
                    </button>
                    <button type="submit" className="su-btn" disabled={!dirty}>
                        Guardar
                    </button>
                </div>
            </form>
        </div>,
        document.body
    );
};
